<template>
  <div class="dropdown no-padding mr-4">
    <button
      id="dropdownMenuButton"
      class="btn no-bg dropdown-toggle text-white"
      style="font-size: 16px;"
      type="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false">
      <span v-if="$store.state.app.lang == 'en'">English</span>
      <span v-if="$store.state.app.lang == 'zh'">简体中文</span>
      <span v-if="$store.state.app.lang == 'id'">Bahasa Indonesia</span>
      <span v-if="$store.state.app.lang == 'vi'">Tiếng Việt</span>
      <span v-if="$store.state.app.lang == 'th'">ภาษาไทย</span>
    </button>
    <div
      class="dropdown-menu dropdown-menu-right"
      aria-labelledby="dropdownMenuButton">
      <a
        class="dropdown-item"
        @click="switchLang('en')"
      >
        English
      </a>
      <a
        class="dropdown-item"
        @click="switchLang('zh')"
      >
        简体中文
      </a>
      <a
        class="dropdown-item"
        @click="switchLang('id')"
      >
        Bahasa Indonesia
      </a>
      <a
        class="dropdown-item"
        @click="switchLang('vi')"
      >
        Tiếng Việt
      </a>
      <a
        class="dropdown-item"
        @click="switchLang('th')"
      >
        ภาษาไทย
      </a>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    switchLang (lang) {
      // change lang
      this.$i18n.locale = lang
      // switch lang
      this.$store.dispatch('switchLang', lang)
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/custom/DropdownLang.vue